export const architectureProjects = [
  {
    "id": 0,
    "headerText": {
      "title": "]Either or[ [both and also]",
      "subTitle": "10 games in metaxourgeio",
      "team": "Miltos Tsakiris, Spyros Kapogiannopoulos",
      "description": "Exploration of enhacing physical public spaces in Athens through game design",
      "eitheror": true,
      // "description": "The general image that exists in the shaping and searching for the ideal form in architectural processes seems to be altered over time. Space producing characteristics and processes are emerging in the contemporary architecture that contribute to the creation of an instability that contradicts the uniqueness and sets the foundation for an architecture free of stability and permanence. We can see, therefore, that the knowledge of space has been separated from the stability of the content and the certainty of the meaning. Its production processes are characterized by complexity and do not bear any obvious intentions. The creation of the space is also not distinguishable from duration of time nor is it captive of the place. In this respect, initially, if we consider Rafel Lozano Hemmer’s relational architecture concepts, which are referring to a technological treatment of buildings and public spaces, we can lay the foundations for an unpredictable and dynamic design of the urban landscape. ",
      
    },

    "imgSrc": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1594138498/EitherOrBothAndAlso/Main_View_Night_u4esa4.jpg",
    "imgZoom": {
      "imgToZoom": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599117561/EitherOrBothAndAlso/EitherOrPoster_Mag_small_px9z4n.jpg",
      "zoomMagImg": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599118046/EitherOrBothAndAlso/EitherOrPoster_Mag_Biggerthanhuge_cwvza9.jpg",
      "zoomImg": true
    },
    "videoHeader": false,
    "selected": false,
    " category": "culture",
    "cards": [],
    "chapters": ""
  },
  {
    "id": 1,
    "headerText": {
      "title": "Pavillion",
      "subTitle": "Ephimeral construction in the roman centre of Thessaloniki",
      "team": "Miltos Tsakiris, Spyros Kapogiannopoulos",
      "description": "This pavilion is being designed to constitue a medium between the archeological site of the Galerius Palace, in Thessaloniki, and the modern inhabitant of the city through the form of an ephemeral and lighweight construction. It proposes a space that is an exhibition center or a place of various events, that simultaneously serves recreation purposes and hosts a cafeteria, a book store and a gift shop. The main designing concept emerged as a result of the effort of combining the historical weight of the site with the emphemerality of a modern constuction. A two-part zoning of this construction was chosen to reflect that idea : on the one hand the representation of the Byzantine masonry, while on the other, the trail of the modern. The conjuction of these conflicting elements is being achieved through a clean, translucent,box that encloses them and tries to develop a dialogue with the urban landscape."
    },
    "imgSrc": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1594140173/Pavilion/Pavillion_lcrqev.jpg",
    "imgZoom": {
      "imgToZoom": "",
      "zoomMagImg": "",
      "zoomImg": false
    },
    "videoHeader": false,
    "selected": false,
    "zoomImg": false,
    " category": "architecture",
    "description": "",
    "chapters": [
      {
        "Pavillion Structure Diagram": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598863663/Pavilion/Pavilion-Structure-Diagram_lzaspn.png",
          "text": "The upper body of the pavilion reffers to the abstract meaning of technology while the lower part is a reminder of the significance of the ruins archaelogical site.",
          "title": "Structure Diagram",
          "color": "#f8f7f9"
        }
      },
      {
        "Pavillion Axonometric Section / Construction Detail": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598861101/Pavilion/Pavilion_Axonometric_Section_irizfd.png",
          "color": "#F7EC59",
          "Chaptertitle": "Structure"
        }
      },
      {
        "Pavillion Top Plan : View of the two levels demostrating the space organisation ": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598810453/Pavilion/Pavilion_Plan_v5rzu8.jpg",
          "color": "#f8f7f9"
        }
      },
      {
        "Perpendicular Section": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598871408/Pavilion/Pavilion-Section-AA_s88txh.png",
          "title": "Plans",
          "text": "The lower level of the construction resembles the form and the texture of the byzantine ruins of the surrounding site and the upper part while holding the frosted roof permits the crossing views of the passing pederstrians.",
          "color": "#f8f7f9"
        }
      },
      {
        "Traverse Section": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598871523/Pavilion/Pavilion-Section-BB_nmnxga.png",
          "color": "#f8f7f9"
        }
      },
      {
        "Pavillion View from the street": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1594140173/Pavilion/Pavilion_Outerior_azvajd.jpg"
        }
      },
      {
        "Pavillion night view": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1594140171/Pavilion/Pavillion_night_sd0p3g.jpg"
        }
      },
      {
        "Pavillion lower floor View": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1594140174/Pavilion/Pavillion_Back_view_jw8soc.jpg"
        }
      }
    ]
  },
  {
    "id": 2,
    "headerText": {
      "title": "Wireframe",
      "subTitle": "Collabrotaive kitchen for Cook8",
      "team": "Miltos Tsakiris, Spyros Kapogiannopoulos",
      "description": "In our day and age dining areas are not limited to specific spaces as people are not using predetermined areas for producing but mostly consuming food. People create, individual or not, comfort conditions. Primary example can constitute the consumption of food in front of the TV. Based on that fact Wire-Frame tries to offer a context in which the social interactions of its users will create a dining area through the individual and collective inventiveness. The aim is the design of a hybrid space that can be constructed through the desires of its users during the food production and consumption. This adjustable space is consisted of 8 frames that while they are rolling capability, they also bear the basic infrastructure that can power a kitchen system, On the frames the users can place the specifically designed adjustable equipment creating unique and various space qualities that will accommodate them. Lastly the frames can also be dismantled and reassembled in purpose of creating seats, if that is what the users want. "
    },
    "imgSrc": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1594140598/Pavilion/Cook8/Render_zxsyjs.jpg",
    "imgZoom": {
      "imgToZoom": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598872716/Cook%2A/Cook8-Aconometric-normal_j9wlrb.png",
      "zoomMagImg": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598872716/Cook%2A/Cook8-Aconometric-normal_j9wlrb.png",
      "zoomImg": true
    },
    "videoHeader": false,
    "selected": false,
    " category": "competition",

    "chapters": [
      {
        "Section A": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599474174/Cook%2A/Section-A_m6rrua.jpg"
        }
      },
      {
        "Section B": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599477128/Cook%2A/Section-B_j6nuuu.jpg"
        }
      }
    ]
  },
]



export const interactiveProjects = [

]

export const allData = [
  {
    "id": 0,
    "headerText": {
      "title": "]Either or[ [both and also]",
      "subTitle": "10 games in metaxourgeio",
      "team": "Miltos Tsakiris, Spyros Kapogiannopoulos",
      "description": "Exploration of enhacing physical public spaces in Athens through game design",
      "eitheror": true,
      // "description": "The general image that exists in the shaping and searching for the ideal form in architectural processes seems to be altered over time. Space producing characteristics and processes are emerging in the contemporary architecture that contribute to the creation of an instability that contradicts the uniqueness and sets the foundation for an architecture free of stability and permanence. We can see, therefore, that the knowledge of space has been separated from the stability of the content and the certainty of the meaning. Its production processes are characterized by complexity and do not bear any obvious intentions. The creation of the space is also not distinguishable from duration of time nor is it captive of the place. In this respect, initially, if we consider Rafel Lozano Hemmer’s relational architecture concepts, which are referring to a technological treatment of buildings and public spaces, we can lay the foundations for an unpredictable and dynamic design of the urban landscape. ",
      
    },

    "imgSrc": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1594138498/EitherOrBothAndAlso/Main_View_Night_u4esa4.jpg",
    "imgZoom": {
      "imgToZoom": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599117561/EitherOrBothAndAlso/EitherOrPoster_Mag_small_px9z4n.jpg",
      "zoomMagImg": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599118046/EitherOrBothAndAlso/EitherOrPoster_Mag_Biggerthanhuge_cwvza9.jpg",
      "zoomImg": true
    },
    "videoHeader": false,
    "selected": false,
    " category": "culture",
    "cards": [],
    "chapters": ""
  },
  {
    "id": 1,
    "headerText": {
      "title": "Pavillion",
      "subTitle": "Ephimeral construction in the roman centre of Thessaloniki",
      "team": "Miltos Tsakiris, Spyros Kapogiannopoulos",
      "description": "This pavilion is being designed to constitue a medium between the archeological site of the Galerius Palace, in Thessaloniki, and the modern inhabitant of the city through the form of an ephemeral and lighweight construction. It proposes a space that is an exhibition center or a place of various events, that simultaneously serves recreation purposes and hosts a cafeteria, a book store and a gift shop. The main designing concept emerged as a result of the effort of combining the historical weight of the site with the emphemerality of a modern constuction. A two-part zoning of this construction was chosen to reflect that idea : on the one hand the representation of the Byzantine masonry, while on the other, the trail of the modern. The conjuction of these conflicting elements is being achieved through a clean, translucent,box that encloses them and tries to develop a dialogue with the urban landscape."
    },
    "imgSrc": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1594140173/Pavilion/Pavillion_lcrqev.jpg",
    "imgZoom": {
      "imgToZoom": "",
      "zoomMagImg": "",
      "zoomImg": false
    },
    "videoHeader": false,
    "selected": false,
    "zoomImg": false,
    " category": "architecture",
    "description": "",
    "chapters": [
      {
        "Pavillion Structure Diagram": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598863663/Pavilion/Pavilion-Structure-Diagram_lzaspn.png",
          "text": "The upper body of the pavilion reffers to the abstract meaning of technology while the lower part is a reminder of the significance of the ruins archaelogical site.",
          "title": "Structure Diagram",
          "color": "#f8f7f9"
        }
      },
      {
        "Pavillion Axonometric Section / Construction Detail": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598861101/Pavilion/Pavilion_Axonometric_Section_irizfd.png",
          "color": "#F7EC59",
          "Chaptertitle": "Structure"
        }
      },
      {
        "Pavillion Top Plan : View of the two levels demostrating the space organisation ": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598810453/Pavilion/Pavilion_Plan_v5rzu8.jpg",
          "color": "#f8f7f9"
        }
      },
      {
        "Perpendicular Section": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598871408/Pavilion/Pavilion-Section-AA_s88txh.png",
          "title": "Plans",
          "text": "The lower level of the construction resembles the form and the texture of the byzantine ruins of the surrounding site and the upper part while holding the frosted roof permits the crossing views of the passing pederstrians.",
          "color": "#f8f7f9"
        }
      },
      {
        "Traverse Section": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598871523/Pavilion/Pavilion-Section-BB_nmnxga.png",
          "color": "#f8f7f9"
        }
      },
      {
        "Pavillion View from the street": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1594140173/Pavilion/Pavilion_Outerior_azvajd.jpg"
        }
      },
      {
        "Pavillion night view": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1594140171/Pavilion/Pavillion_night_sd0p3g.jpg"
        }
      },
      {
        "Pavillion lower floor View": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1594140174/Pavilion/Pavillion_Back_view_jw8soc.jpg"
        }
      }
    ]
  },
  {
    "id": 2,
    "headerText": {
      "title": "Wireframe",
      "subTitle": "Collabrotaive kitchen for Cook8",
      "team": "Miltos Tsakiris, Spyros Kapogiannopoulos",
      "description": "In our day and age dining areas are not limited to specific spaces as people are not using predetermined areas for producing but mostly consuming food. People create, individual or not, comfort conditions. Primary example can constitute the consumption of food in front of the TV. Based on that fact Wire-Frame tries to offer a context in which the social interactions of its users will create a dining area through the individual and collective inventiveness. The aim is the design of a hybrid space that can be constructed through the desires of its users during the food production and consumption. This adjustable space is consisted of 8 frames that while they are rolling capability, they also bear the basic infrastructure that can power a kitchen system, On the frames the users can place the specifically designed adjustable equipment creating unique and various space qualities that will accommodate them. Lastly the frames can also be dismantled and reassembled in purpose of creating seats, if that is what the users want. "
    },
    "imgSrc": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1594140598/Pavilion/Cook8/Render_zxsyjs.jpg",
    "imgZoom": {
      "imgToZoom": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598872716/Cook%2A/Cook8-Aconometric-normal_j9wlrb.png",
      "zoomMagImg": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598872716/Cook%2A/Cook8-Aconometric-normal_j9wlrb.png",
      "zoomImg": true
    },
    "videoHeader": false,
    "selected": false,
    " category": "competition",

    "chapters": [
      {
        "Section A": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599474174/Cook%2A/Section-A_m6rrua.jpg"
        }
      },
      {
        "Section B": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599477128/Cook%2A/Section-B_j6nuuu.jpg"
        }
      }
    ]
  },
  {
    "id": 3,
    "headerText": {
      "title": "Solobot",
      "subTitle": "A creative robot",
      "team": "Miltos Tsakiris, Juan Cabrera",
      "description": "Solobot is a project inspired by the creation process of Sol Lewitt. Instead of executing the works of art himself, LeWitt came up with an idea or plan for his art, usually a set of simple instructions. He then handed over the written plan to his assistants, and they constructed the work."
    },
    "imgSrc": "https://firebasestorage.googleapis.com/v0/b/miltostsakirisportfolio.appspot.com/o/Solobot%2FThumbnail%2FSolobot.jpg?alt=media&token=90075a4c-c80c-40b2-a13f-d60c521e2da7",
    "imgZoom": {
      "imgToZoom": "",
      "zoomMagImg": "",
      "zoomImg": false
    },
    "videoHeader": true,
    "selected": false,
    " category": "interaction",
    "videoSrc": "https://res.cloudinary.com/dcoz5uxjg/video/upload/v1596536620/Solobot/PATHWAY_ONE_Solobot_-_Miltos_Tsakiris_Juan_Cabrera_jpje3n.mp4",
    "chapters": [
      {
        "Solobot Design Exploded": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598623637/Solobot/Concept_icbegm.png",
          "text": "This idea represents a provocation between machine understanding and human understanding of instructions when producing  drawings.It surfaces the boundaries of biases in simple machine learning algorithms and shows the depth and complexity of human interpretation.",
          "title": "Concept"
        }
      },
      {
        "Mirobot Design": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598623202/Solobot/Solobot_rytqpc.png",
          "text": "This platform provides a new and creative way to communicate by incorporating music-creating processes with the natural instrument humans are born with, voice. Being inspired by the community characteristics of a choir we applied them in our project. Being a part of such music-creating process is a fascinating outlet for people, especially during this global pandemic. The Bitmap Choir aims to provide a platform for people to express and communicate without a language barrier. Due to different lockdown measures around the globe, humans are developing new ways to socialize. Traditional face-to-face socialization is being transplanted into the virtual world. The virtual world is structured and presented by pixels in our everyday communication devices. The only way to indicate humans’ socialization during lockdown is by analyzing their digital presence. Therefore, we created a platform that uses the microphone as the main interactive input. During the period of various lockdowns and social distancing, individuals are isolated in a specic 3D space. We looked at this isolated 3D space as isolated blocks, and each block is acting as one single module around the globe. We wanted to bring these isolated blocks together by harmonizing them with music through Bitmap Choir.",
          "title": "Concept"
        }
      },
      {
        "Solobot Design Exploded": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598623202/Solobot/Solobot-Exploded_icjses.png"
        }
      }
    ]
  },
  {
    "id": 4,
    "headerText": {
      "title": "Poster Generator",
      "subTitle": "Bauhaus inspired generative and interactive poster",
      "team": "Miltos Tsakiris",
      "description": "My proposal is inspired by the Posters, issued by the Bauhaus school. I created a Poster generator that populates the browser canvas with primitive shapes creating a spatial composition of planes, lines, semicylinders, and boxes. All the shapes that are drawn are created by 2d shapes forming volumes and not with WebGL environment and cameras, in my effort to respect the Bauhaus drawing process. In the bottom right corner of my Canvas, I draw people's names and institutions that had to do with Bauhaus (Joseph Albers, Mies van de Rohe, Bauhaus Archive : taken by WikiData json file) as well as the dates of their birth, and I update them every second my sketch is running. Next to that that there is drawn a counter of my sketch's life.The Poster generator creates its composition in random positions on the Canvas and with random Shape order and selection, based on the time the sketch is running. Adding to that the user can draw with the shapes generated with the position of the Mouse or with the Raspberry pi's gyroscope values in a co-creating way with the random - animation in the background. All the shapes that are being created have an embodied motion along the Y-axis with small variations from object to object, which makes the Poster generator look alive and self - creating. "
    },
    "imgSrc": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1596788673/Poster%20Generator/Poster_Generator_rd0afz.png",
    "imgZoom": {
      "imgToZoom": "",
      "zoomMagImg": "",
      "zoomImg": false
    },
    "glitch": {
      "url": "https://weirde-de-stijl.glitch.me/"
    },
    "videoHeader": true,
    "videoSrc": "https://res.cloudinary.com/dcoz5uxjg/video/upload/v1598703263/Poster%20Generator/MiltosTsakiris_PosterGenerator_DoubleSpeedAnimation_dretn7.mp4",
    "selected": false,
    "category": "creative-coding",
    "chapters": [
      {
        "Brazil": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598872963/Poster%20Generator/Brazil_pgijkb.png",
          "title": "Flags Generator",
          "text": ""
        }
      },
      {
        "Sahrawi Arab Democratic": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598872976/Poster%20Generator/Sahrawi_Arab_Democratic_Republic_sstdzp.png",
          "title": ""
        }
      },
      {
        "State of Palestine": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598872977/Poster%20Generator/State_of_Palestine_anfstq.png",
          "title": ""
        }
      },
      {
        "Qatar": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598872976/Poster%20Generator/Qatar_e5wjzc.png",
          "title": ""
        }
      },
      {
        "Papua New Guinea": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598872975/Poster%20Generator/Papua_New_Guinea_msywm8.png",
          "title": ""
        }
      },
      {
        "Montenegro": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598872973/Poster%20Generator/Montenegro_tgbsam.png",
          "title": ""
        }
      },
      {
        "Liberia": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598872971/Poster%20Generator/Liberia_h230th.png",
          "title": ""
        }
      }
    ]
  },
  {
    "id": 5,
    "headerText": {
      "title": "Allatini",
      "subTitle": "Urban Re-design project of the factory of Allatini in Thessaloniki",
      "team": "Miltos Tsakiris, Emma Reppa, Elli Petridi",
      "description": "Allatini Urban Proposal consists of a complex of building on the coast of Thessaloniki .It is divided by one residential Zone that surrounds the Public park in the middle of the Plan that gets crossed by a big pedestrian way that leads to Thessaloniki Coast. The main Building of the previous Industrial Area is kept untouched and it is designed to host the program of a hotel on this very interesting landscape. In the entrance to the Urban Plan there has been placed a multi-functional building that facilitates the immediate needs of the residents. The horizontal line that divides the urban Plan in two sections is a boulevard that remains intact just a few meters below the Allatini level to facilitate the vehicles flow without disturbing the users of the project."
    },
    "imgSrc": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1596791268/Alatini/21_edited_jz1nsu.jpg",
    "imgZoom": {
      "imgToZoom": "",
      "zoomMagImg": "",
      "zoomImg": false
    },
    "videoHeader": false,
    "selected": false,
    " category": "urbanism",

    "chapters": [
      {
        "Plan View": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598808599/Alatini/%CE%BA%CE%B1%CF%84%CE%BF%CF%88%CE%B5%CE%B9%CF%82-photoshop-flatten_ejd1y8.jpg",
          "text": "",
          "title": ""
        }
      },
      {
        "Conceptual Drawing": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598804286/Alatini/allatini-diagram_qmuc7e.png",
          "text": ""
        }
      },
      {
        "Conceptual Drawing": {
          "text": "dsfshglkjdfgk,df"
        }
      }
    ]
  },
  {
    "id": 6,
    "headerText": {
      "title": "Rube Goldberg Machine",
      "subTitle": "A chain of actuators and sensors",
      "team": "Wei-Lin Chang, Zoe Diakaki, Miltos TSakiris, Yuqing Liu, Connie Weiqi Huang, Juan Camilo Cabrera, Spiros Kapogiannopoulos, Ravin Raori, Jaehyeong Yoo, Hepu Wei, Zexuan Qiao, Yuntong Song",
      "description": "This project is inspired b"
    },
    "imgSrc": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1596796770/Rube%20Goldberg%20Machine/Arduino_Workshop_z6grae.jpg",
    "imgZoom": {
      "imgToZoom": "",
      "zoomMagImg": "",
      "zoomImg": false
    },
    "videoHeader": true,
    "selected": false,
    " category": "prototype",

    "videoSrc": "https://res.cloudinary.com/dcoz5uxjg/video/upload/v1598520004/Rube%20Goldberg%20Machine/Rube_Goldberg_Machine_-_P1_1_wyplrx.mp4",
    "chapters": [
      {
        "Design of the chained structure": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599083636/Rube%20Goldberg%20Machine/20200121_STRUCTURE_PTH03_MILTOS_RHINO5.3dm_229_MB_-_Rhino_6_Evaluation_5_Days_Remaining_-_Parallel_03_09_2020_00_53_11_abt1dw.png",
          "color": "#A2ABB5",
          "Chaptertitle": "Design && Modeling"
        }
      },
      {
        "The materials used for the construction of the project": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599084855/Rube%20Goldberg%20Machine/Materials_hnptfj.jpg",
          "text": " Following the design process, the platforms of the scaffolding construction were fabricated by a Laser cutting machine. With the use of double nuts on both sides of the platform each working module was levelled and tied on the structure.",
          "title": "Materials",
          "Chaptertitle": "Implementation ",
          "color": "#f8f7f9"
        }
      },
      {
        "Assembly": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599084855/Rube%20Goldberg%20Machine/Assembly_g4htuf.jpg",
          "color": "#f8f7f9",
          "text": ""
        }
      },

      {
        "Assembly": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599084854/Rube%20Goldberg%20Machine/Assembly2_ujhwin.jpg",
          "color": "#f8f7f9"
        }
      },
      {
        "LCD Moisture Indication": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599084853/Rube%20Goldberg%20Machine/IAMDRY_rrfdmz.jpg",
          "color": "#f8f7f9"
        }
      },
      {
        "Complete Machine": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599084855/Rube%20Goldberg%20Machine/Final_nxmors.jpg",
          "color": "#f8f7f9"
        }
      }
    ]
  },
  {
    "id": 7,
    "headerText": {
      "title": "Behind Creation",
      "subTitle": "Exploring the subface 'Damage behind creation'",
      "team": "Wei-Lin Chang, Miltos Tsakiris, Jaehyeong Yoo",
      "description": "‘Behind Creation’ is a set of iterations that operates on the subface, ‘Damage behind Creation’, we as designers set to discover and develop our project upon. Frieder Nake defines subface as a space that is the opposite of surface, where things are non-evident. Taking the screen as an example, ‘the display buffer is the subface’ (Nake, 2008). Designer Wei-Lin came from classical music and business background, Jaehyeong came from a spatial and graphic design background, and Miltos came from an architecture and engineering background. We were interested in the different creation process from our very different backgrounds, where we discovered that physical and non-physical damage plays a crucial role behind creations. The relationship between damage and creation defines a very fine balance that individually without the other, one cannot fully display its beauty."
    },
    "imgSrc": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1596797353/Behind%20Creation/Behind_Creation_Miltos_Tsakiris_b12fu9.jpg",
    "imgZoom": {
      "imgToZoom": "",
      "zoomMagImg": "",
      "zoomImg": false
    },
    "videoHeader": false,
    "selected": false,
    " category": "competition",

    "chapters": [
      {
        "Axonometric exploded ": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599620752/Behind%20Creation/Asset_1_vl2ycy.svg",
          "Chaptertitle": "In-Game Page",
          "color": "#232323",
          "textColor": "white",
          "type": "image"
        }
      },
      {
        "Concept": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599561491/Behind%20Creation/Concept_Table_x8r2fp.svg",
          "text": "Behind Creation discovers the subface, ‘Damage behind Creation’, through various prototypes. We began our concept with a chart of an artist’s creation process from input to output and developed our prototypes based on this structure. Initially, we discussed different creation processes, such as a sculptor creating a sculpture and a luthier building an instrument. What fascinates us about sculpting and instrument-building is the debris, wood dust, and tested-strings that come alongside the process. The creation is not as substantial without all these different forms of damage that come with it. During our prototyping, we tested different damaging forces to further our understanding of the relationship between damage and creation. We also re-purposed electronics, objects, and wastes that resonate with our subface, where these damaged objects are being used as a creation material. Our project Bitmap Choir operates on the subface by reflecting upon the inevitable damage during COVID-19. Social damage leads us to build a creative way of communication. ",
          "title": "Concept",
          "type": "image"
        }
      },
      {
        "Concept": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/video/upload/v1598709357/Behind%20Creation/Behind_Creation_Miltos_Tsakiris_dbmahp.mp4",
          "text": "Behind Creation discovers the subface, ‘Damage behind Creation’, through various prototypes. We began our concept with a chart of an artist’s creation process from input to output and developed our prototypes based on this structure. Initially, we discussed different creation processes, such as a sculptor creating a sculpture and a luthier building an instrument. What fascinates us about sculpting and instrument-building is the debris, wood dust, and tested-strings that come alongside the process. The creation is not as substantial without all these different forms of damage that come with it. During our prototyping, we tested different damaging forces to further our understanding of the relationship between damage and creation. We also re-purposed electronics, objects, and wastes that resonate with our subface, where these damaged objects are being used as a creation material. Our project Bitmap Choir operates on the subface by reflecting upon the inevitable damage during COVID-19. Social damage leads us to build a creative way of communication. ",
          "title": "Concept",
          "type": "video"
        }
      },
      {
        "Working Process": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598901343/Behind%20Creation/Development_p13f3y.svg",
          "type": "image"
        }
      },
      {
        "Concept Process": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598901592/Behind%20Creation/Concept_Process_zegytp.svg",
          "type": "image"
        }
      },
      {
        "Top View of Prototype 2.0": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598901950/Behind%20Creation/proototype_2.0_higsae.svg",
          "Chaptertitle": "Prototype 2.0",
          "type": "image"
        }
      },
      {
        "Detailed Aconometric View of Prototype 2.0": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598902214/Behind%20Creation/prototype_2.0_exploded_lcyi8e.svg",
          "color": "#232323",
          "type": "image"
        }
      }
    ]
  },
  {
    "id": 8,
    "headerText": {
      "title": "Bitmap Choir",
      "subTitle": "A collaborative music game",
      "team": "Wei-Lin Chang, Miltos Tsakiris, Jaehyeong Yoo",
      "description": "The Bitmap Choir is a platform that invites people with or without musical training to express and enjoy a collaborative music-creating experience through gamified interactions. It is designed to gather people around the world to sing together, allowing anyone to create and and expression through our universal language, music.The creators of The Bitmap Choir were inspired to create this platform in response to the global social damage during COVID-19.This social interruption has transplanted physical face-to-face interactions into virtual space via pixels behind our screens. Despite the disruptions, we are creating new forms of communication to generate musical creation from social damage.Our pixelated visual design amplifies how the virtual world is constructed behind screens. In The Bitmap Choir’s grid of gigantic pixels, columns represent chords, and rows represent musical notes each participant has to sing. As a choir, participants are given a set timeframe to reach the assigned musical note in order to proceed to the next chord. At the end of the performance, your choir will be able to playback and download your expressive creation."
    },
    "imgSrc": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598436782/BitmapChoir/WireFrame_afjn29.png",
    "imgZoom": {
      "imgToZoom": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598463304/BitmapChoir/WireFrame_kptmle.png",
      "zoomMagImg": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598529611/BitmapChoir/WireFrame-grey_hyqz8c.png",
      "zoomImg": true
    },
    "videoHeader": true,
    "selected": false,
    " category": "competition",
    "videoSrc": "https://res.cloudinary.com/dcoz5uxjg/video/upload/v1598515390/BitmapChoir/20200715_FINAL_FOR_GOLDEN_PIN_nddx4r.mp4",
    "chapters": [
      {
        "Conceptual Drawing": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598604424/BitmapChoir/Conceptual_Drawing_sekcga.png",
          "text": "This platform provides a new and creative way to communicate by incorporating music-creating processes with the natural instrument humans are born with, voice. Being inspired by the community characteristics of a choir we applied them in our project. Being a part of such music-creating process is a fascinating outlet for people, especially during this global pandemic. The Bitmap Choir aims to provide a platform for people to express and communicate without a language barrier. Due to different lockdown measures around the globe, humans are developing new ways to socialize. Traditional face-to-face socialization is being transplanted into the virtual world. The virtual world is structured and presented by pixels in our everyday communication devices. The only way to indicate humans’ socialization during lockdown is by analyzing their digital presence. Therefore, we created a platform that uses the microphone as the main interactive input. During the period of various lockdowns and social distancing, individuals are isolated in a specic 3D space. We looked at this isolated 3D space as isolated blocks, and each block is acting as one single module around the globe. We wanted to bring these isolated blocks together by harmonizing them with music through Bitmap Choir.",
          "title": "Concept"
        }
      },
      {
        "Landing Page": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598604422/BitmapChoir/Landing_Page_mjphkf.png"
        }
      },
      {
        "Singing / Composition Mode": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598604422/BitmapChoir/Singing_Composition_Mode_uorztc.png"
        }
      },
      {
        "Customization Page": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598604421/BitmapChoir/Customization_ygbddw.png",
          "text": "Set each round’s gameplay time by clicking the arrow to the left and to the right, then customize and save your character by browsing the list of characters given and finally press Sing.",
          "title": "Customization"
        }
      },
      {
        "Customization Examples": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598604421/BitmapChoir/Customization_Examples_foxbfx.png"
        }
      },
      {
        "Create Room": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598441011/BitmapChoir/GPDA_BitmapChoir4.0_Room_Creating_isjwgy.png"
        }
      },
      {
        "Main Page": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598440950/BitmapChoir/GPDA_BitmapChoir4.0_Gameplay_Animations_1_dmxsrj.png"
        }
      },
      {
        "Volume Mixer & Instrument ": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598878761/BitmapChoir/SoundMixer_j8wlqf.png",
          "color": "#668586",
          "Chaptertitle": "Sound Customization"
        }
      },
      {
        "Scoreboard": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598440972/BitmapChoir/GPDA_BitmapChoir4.0_InGame_Scoreboard_mjdogj.png"
        }
      },
      {
        "Downloading and saving group performance": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598440969/BitmapChoir/GPDA_BitmapChoir4.0_InGame_-_Save_gidnaw.png"
        }
      },
      {
        "Select Music": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598440997/BitmapChoir/GPDA_BitmapChoir4.0_Music_Selecting_ba0lyq.png"
        }
      },
      {
        "Main Page ": {
          "text": "Bitmap Choir requires each participant to sing the given note in tune. When 3 other participants join a room, the choir starts. The specific given note every participant has to sing is indicated by color and number on the upper right-hand side. The colorful slider bar below it indicates how far one is from the assigned note. Press and hold the spacebar to activate your microphone and sing your note. Participants can click on the lower colorful buttons to listen to the already installed notes to assist them during the singing process. The mixer interface on the lower left-hand corner allows each participants to adjust the volume of his or her own voice and other’s volume. The chord bars on the top also function as a timer that counts down before the whole choir advances to the next chord. Participants who don’t reach the assigned note within the timeframe will get points deduction.",
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598440986/BitmapChoir/GPDA_BitmapChoir4.0_InGame_bwtary.png",
          "color": "#93C6D6",
          "title": "In-Game Page"
        }
      },
      {
        "In Game : Characters": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598440960/BitmapChoir/GPDA_BitmapChoir4.0_Gameplay_Animations_2_x2u0sg.png"
        }
      },
      {
        "In Game : Chords": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598440948/BitmapChoir/GPDA_BitmapChoir4.0_Gameplay_Animations_3_kqa4gd.png"
        }
      },
      {
        "Drag & Drop Composition Mode": {
          "text": "In the first tab of the composition mode, the user can paint his or her own notes with the bucket tool. Then, drag & drop them onto the canvas. By stretching the notes-tiles, the user determines the length of each note.",
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598440953/BitmapChoir/GPDA_BitmapChoir4.0_Drag_Drop_Start_lrinpm.png",
          "color": "#A7ACD9",
          "title": "Drag & Drop Composition Mode"
        }
      },
      {
        "Finishing Composition": {
          "text": "When the positional arrangements have been configured, the track can be played and potentially revised. In the bottom left corner of the tab, there is a mini-map indicator which shows the overall composition visually. The title and the speed of the track can be set, and finally the creation can be saved and uploaded to the platform.",
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598440950/BitmapChoir/GPDA_BitmapChoir4.0_Drag_Drop_End_tb0lta.png",
          "color": "#A7ACD9",
          "title": "Finishing Composition"
        }
      },
      {
        "Finishing Composition": {
          "text": "When the positional arrangements have been configured, the track can be played and potentially revised. In the bottom left corner of the tab, there is a mini-map indicator which shows the overall composition visually. The title and the speed of the track can be set, and finally the creation can be saved and uploaded to the platform.",
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598440998/BitmapChoir/GPDA_BitmapChoir4.0_Musical_Notation_pdlrib.png",
          "title": "Musical Notation Composition Mode"
        }
      },
      {
        "Album Cover": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598440911/BitmapChoir/GPDA_BitmapChoir4.0_AC._PopUp_htjf4o.png"
        }
      },
      {
        "Album Cover Customization": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598441031/BitmapChoir/GPDA_BitmapChoir4.0_AC._Making_Page_uwyxb0.png"
        }
      },
      {
        "Album Cover Customization Examples - Pixel": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598440924/BitmapChoir/GPDA_BitmapChoir4.0_D._Album_Cover_Pixel_vrcffv.png"
        }
      },
      {
        "Album Cover Customization Examples - Custom": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598441031/BitmapChoir/GPDA_BitmapChoir4.0_D._Album_Cover_Costumize_zppsgm.png"
        }
      },
      {
        "Save Composition": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598441019/BitmapChoir/GPDA_BitmapChoir4.0_Save_Composition_Drag_Drop_hcbr74.png"
        }
      }
    ]
  },
  {
    "id": 8,
    "headerText": {
      "title": "PopCorn Arcade",
      "subTitle": "⚡NEEDS DESCRIPTION⚡",
      "team": "Wei-Lin Chang, Miltos Tsakiris, Jaehyeong Yoo",
      "description": ""
    },
    "imgSrc": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1596796770/Rube%20Goldberg%20Machine/Arduino_Workshop_z6grae.jpg",
    "imgZoom": {
      "imgToZoom": "",
      "zoomMagImg": "",
      "zoomImg": false
    },
    "videoHeader": true,
    "selected": false,
    " category": "prototype",

    "videoSrc": "https://res.cloudinary.com/dcoz5uxjg/video/upload/v1599210024/Pop-Corn%20Cannon/Making_Of_vejfjh.mp4",
    "chapters": ""
  },
  {
    "id": 9,
    "headerText": {
      "title": "Water Me",
      "subTitle": "A smart remote watering system",
      "team": "Miltos Tsakiris, Marta Soto Morras",
      "description": "We are leaving the apartment for the next month or two, so we made this self watering system, with a NodeMcu connected to wifi, and a website that we'll use to water the plants! we put some pumps in the toilet flush, as it mechanically refills the water every time it empties. Let's see how the plants get through this in a couple months!Using nodeMCU, firebase, svelte,"
    },
    "imgSrc": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598713881/WaterMe/Water-Me_tlunvj.jpg",
    "imgZoom": {
      "imgToZoom": "",
      "zoomMagImg": "",
      "zoomImg": false
    },
    "videoHeader": false,
    "selected": false,
    " category": "prototype",

    "videoSrc": "https://res.cloudinary.com/dcoz5uxjg/video/upload/v1598714444/WaterMe/VID_20200701_142330_jizqsk.mp4",
    "chapters": "",
    "videos": [
      {
        "videoSrc": "https://res.cloudinary.com/dcoz5uxjg/video/upload/v1598718553/VID_20200701_142330_1_ky3hr6.mp4",
        "width": "35%",
        "height": "auto",
        "title": "Application Overview"
      },
      {
        "videoSrc": "https://res.cloudinary.com/dcoz5uxjg/video/upload/v1598718945/VID_20200701_181210_h252lj.mp4",
        "width": "100%",
        "height": "auto",
        "title": "Dripping System"
      }
    ]
  },
  {
    "id": 10,
    "headerText": {
      "title": "Ambiances",
      "subTitle": "Ephimeral Stage for 'Ambiances Tomorrow' Conference",
      "team": "Miltos Tsakiris, Spyros Kapogiannopoulos",
      "description": ""
    },
    "imgSrc": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598525846/Ambiances/ambience_prwino_render_ikikc6.jpg",
    "imgZoom": {
      "imgToZoom": "",
      "zoomMagImg": "",
      "zoomImg": false
    },
    "videoHeader": false,
    "selected": false,
    " category": "prototype",

    "videoSrc": "https://res.cloudinary.com/dcoz5uxjg/video/upload/v1598714444/WaterMe/VID_20200701_142330_jizqsk.mp4",
    "chapters": [
      {
        "Conceptual Drawing": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598809035/Ambiances/render1_ya8tnz.jpg"
        }
      },
      {
        "Landing Page": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1598809046/Ambiances/render2_wvwn6s.jpg"
        }
      }
    ],
    "videos": []
  },
  {
    "id": 11,
    "headerText": {
      "title": "Blade Runner",
      "subTitle": "An industrial machine die cutting machine",
      "team": "Miltos Tsakiris, Stelios Tsakiris",
      "description": "This project is based on the functional combination of 2 mechanical systems : a 4 axis CNC system and a variation of the Di.Wire of Pensa Labs. It is designed as a desktop – industrial machine which can bend specific blades in every angle as well as place the formatted blade with great accuracy in order to create custom shaped blades. The machine runs the firmware Marlin and it understands commands in G-code. Both motorized systems are being drived by Stepper drivers and controlled by 2 Arduino Megas.The interface which I designed to run the machine is entirely made in Processing and the physical communication with the computer is implemented via USB and Serial communication. The developed software can load complex geometries in “.svg” format and it can interpret the shape in a G-code file which is loaded to the Arduinos when they are about to operate"
    },
    "imgSrc": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599744842/Blade%20Runner/General-View-Suction-Angle_wypsz9.jpg",
    "imgZoom": {
      "imgToZoom": "",
      "zoomMagImg": "",
      "zoomImg": false
    },
    "videoHeader": false,
    "selected": false,
    " category": "prototype",

    "chapters": [
      {
        "Wireframe - Workflow": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1600082587/Blade%20Runner/Wireframe_Diagram_zo0wbr.svg",
          "title": "Bender - Prototype",
          "color": "#afbed1"
        }
      },
      {
        "Suction system : Plan View": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599744838/Blade%20Runner/Suction-Plan_ygcrce.jpg"
        }
      },
      {
        "Parametric model : 3d view in Rhinoceros 6": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599759434/Blade%20Runner/gh-3d-model_sh7r89.jpg",
          "color": "#9ca3ab",
          "text": "For the design of the press table mechanism, we developed a parametric tool to iterate through different parameters of the crank-slide mechanism which is responsible for the horizontal movement of the press table.",
          "title": "Parametric Design of slider-crank mechanism"
        }
      },
      {
        "Axonometric explanatory drawing about the machine's production and process zones ": {
          "url": "https://res.cloudinary.com/dyxlwvrnp/image/upload/v1601044077/Blade%20Runner/CNC-drawing_kuxvwb.png"
        }
      },

      {
        "Parametric model : A parametric model to simulate the design of the table mechanism was essntial for all the prototypes": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599758091/Blade%20Runner/gh_m7qzyy.png",
          "title": "Parametric Design of slider-crank mechanism"
        }
      },
      {
        "Genral View": {
          "Chaptertitle": "Construction",
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1599758088/Blade%20Runner/Generall-Warehouse-Side-_z5v47s.jpg"
        }
      },
      {
        "Genral View": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/video/upload/v1600075562/Blade%20Runner/06_vzfmh7.mp4",
          "type": "video",
          "title": "Bender - Prototype",
          "text": "The Bender CNC system is the most important subsystem of the machine. It is responsible for the formation of the cutting die blade in the appropriate shape to fit the cutting mold during the pressing routine later in the process. It consists of 2 stepper motors that are controlling the horizontal movement and the bending of the blade."
        }
      },
      {
        "Bender Head : Later we added an angle correction system which helps with the calibration of the machine every time a shape is produced.": {
          "url": "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1600094595/Blade%20Runner/IMG_20200910_134658_mrfaia.jpg",
          "type": "image"
        }
      }
    ],
    "videos": []
  }
]
